export enum AvailableStatus {
  available = "available",
  notAvailable = "notAvailable",
  both = "both",
}
export const availableStatuses = [
  { value: AvailableStatus.available, name: "Dostępne" },
  { value: AvailableStatus.notAvailable, name: "Zajęte" },
  { value: AvailableStatus.both, name: "Wszystkie" },
];
